import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MdModule } from '../../md/md.module';

import { DashboardComponent } from './dashboard.component';
import { DashboardRoutes } from './dashboard.routing';
import { MaterialModule } from 'src/app/material.module';
import { CalendarModule } from 'src/app/shared/calendar/calendar.module';

@NgModule({
    imports: [CommonModule, RouterModule.forChild(DashboardRoutes), FormsModule, MdModule, MaterialModule, CalendarModule],
    declarations: [DashboardComponent],
})
export class DashboardModule {}
